module.exports = __webpack_public_path__ + "static/media/hospitals.e8b9a9cd.svg";